import React, { memo, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Menus, Link, Text, Icon } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../lib/Web5Context";
import FormsIcon from "../icons/FormsIcon";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'FormsListItem');
var _ref2 = /*#__PURE__*/React.createElement(FormsIcon, null);
var _ref3 = /*#__PURE__*/React.createElement(Icon, {
  name: "lock",
  size: "small"
});
var _ref4 = /*#__PURE__*/React.createElement(Icon, {
  name: "threeDots"
});
function FormsListItem(_ref) {
  let {
    id,
    idFormType,
    pos11,
    pos12,
    pos13,
    pos21,
    pos22,
    pos23,
    readOnly,
    openDetail,
    editForm,
    deleteForm,
    style
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const items = useMemo(() => {
    const menuItems = [];
    if (editForm) menuItems.push({
      title: /*#__PURE__*/React.createElement(Text, null, readOnly ? t('action_view') : t('action_edit')),
      onClick: () => editForm && editForm(id, idFormType)
    });
    if (deleteForm) menuItems.push({
      title: /*#__PURE__*/React.createElement(Text, null, t('action_delete')),
      onClick: () => deleteForm && deleteForm(id)
    });
    return menuItems;
  }, [t, readOnly, editForm, id, idFormType, deleteForm]);
  const handleOnClick = useCallback(() => {
    openDetail(id);
  }, [id, openDetail]);
  const menusClasses = useMemo(() => ({
    subMenu: classes.subMenu
  }), [classes.subMenu]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.icons
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formIcon
  }, _ref2), readOnly ? /*#__PURE__*/React.createElement("div", {
    className: classes.lockIcon
  }, _ref3) : null), /*#__PURE__*/React.createElement("div", {
    className: classes.lineBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.positions
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
    className: classes.position,
    onClick: handleOnClick
  }, pos11), /*#__PURE__*/React.createElement(Text, {
    className: classes.position
  }, pos12), /*#__PURE__*/React.createElement(Text, {
    className: classes.position
  }, pos13)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    className: classes.position,
    type: "bold"
  }, pos21), /*#__PURE__*/React.createElement(Text, {
    className: classes.position
  }, pos22), /*#__PURE__*/React.createElement(Text, {
    className: classes.position
  }, pos23 || id))), !!items.length && /*#__PURE__*/React.createElement(Menus, {
    className: classes.menu,
    icon: _ref4,
    items: items,
    classes: menusClasses,
    size: "small"
  })));
}
process.env.NODE_ENV !== "production" ? FormsListItem.propTypes = {
  id: PropTypes.number.isRequired,
  pos11: PropTypes.string,
  pos12: PropTypes.string,
  pos13: PropTypes.string,
  pos21: PropTypes.string,
  pos22: PropTypes.string,
  pos23: PropTypes.string,
  readOnly: PropTypes.bool
} : void 0;
export default /*#__PURE__*/memo(FormsListItem);